<template>
  <div
    class="distributingRunPage mainPageBg"
    v-loading="$store.state.user.loadingState"
  >
    <div class="leftBox">
      <TreeMenu @getActiveItem="getActiveItem" :pageName="'配电系统'" />
    </div>
    <div class="rightBox ashComWrap">
      <RightContent :menuData="menuData" />
    </div>
  </div>
</template>

<script>
import TreeMenu from "@/components/zixitong/TreeMenu";
import RightContent from "@/components/zixitong/distributionSystem/RightContent.vue";
export default {
  components: {
    TreeMenu,
    RightContent,
  },
  data() {
    return {
      menuData: {},
    };
  },
  methods: {
    getActiveItem(data) {
      this.menuData = data;
    },
  },
};
</script>

<style lang="scss" scoped>
.distributingRunPage {
  @include setFlexBetween;
  .leftBox {
    @include setMenuWH;
  }
  .rightBox {
    @include setCenterWH;
  }
}
</style>
